module.exports = __webpack_public_path__ + "static/media/person.40d4f0ad.svg";